import AuthStore from 'stores/AuthStore';
import React from 'react';
import './Navigation.styl';

/**
 * Render top navigation tabs, filtered by the following rules:
 * - role based options
 * - feature flag based options
 * - grab bag "advanced" options
 *
 *  ...unless...
 *
 *  If there are any NavOverrides in the NavStore, in which case we defer to them (they will, however, be nested
 *  inside the dom somewhere to allow for sticky nav to work). See FileUploadCallCard
 */
export default class Navigation extends React.Component {
  render() {
    const {user} = AuthStore.getState();
    if (!user) {
      return null;
    }

    const navbar = this.props.links.filter(
      ({roles, flags, advanced}) =>
        (!roles || roles.includes(user.role)) &&
        (!flags || user.flags.some(f => flags.includes(f))) &&
        (!advanced || advanced(this.state, user))
    );

    return (
      <div className="navigation-rebrand">
        {navbar.map(item => {
          const Renderer = item.renderer;
          return <Renderer key={item.name} item={item} location={this.props.location} />;
        })}
      </div>
    );
  }
}
